import React, { useEffect, useState } from 'react';
import './MainComponent.scss';
import PlaywatchHeader from './Header';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getUserClaims } from 'features/application/application-slice';
import { ContentCarrier, CustomerSettings } from 'models';
import {
    fetch_customer_settings_for_domain,
    get_content_carrier,
    retrieve_current_coherent_screen
} from 'features/auto-thunks';
import PlaywatchMainContent from './MainContent';
import Footer from './Footer';
import Splash from './Splash';
import Gutter from './Gutter';
import { PlaywatchKidsProvider, usePlaywatchKids } from './Context';
import MainPlayContent from './MainPlayContent';
import MediaContentList from './MediaContentList';
import ProfileSection from 'layout/NetflixLayout/Header/ProfileSection';
import IntroAnimation from './IntroAnimation';
import SubscribePanel from './SubscribePanel';
type Props = {};

const MainComponent: React.FC<Props> = ({
}) => {
    const claims = useSelector(getUserClaims);
    const params = useParams();
    const { searchFocused, selectedMedia, showSide, contentCarrier } = usePlaywatchKids();
    const headerContent = <PlaywatchHeader contentCarrier={contentCarrier} />;
    const mainContent = !selectedMedia ? <PlaywatchMainContent contentCarrier={contentCarrier} /> : <MainPlayContent />;
    const sidePanelContent = selectedMedia ? <MediaContentList contentCarrier={contentCarrier} /> : null;
    const sidePanelPosition = 'right';// default to 'left'
    const [showAnimation, setShowAnimation] = useState(true);
    useEffect(() => {
        setTimeout(() => {
            setShowAnimation(false);
        }, 8000)
    }, []);

    if (showAnimation) {
        return <IntroAnimation />
    }
    return (
        <>

            <div className={`layout ${sidePanelPosition}`}>
                {headerContent}
                <div style={{ position: 'relative' }}>
                    <div className={'popper-hook'} style={{
                        position: 'absolute',
                        left: 10,
                        top: -130,
                        width: 0,
                        height: 0
                    }}></div>
                </div>
                {claims && !claims?.subscription ? <SubscribePanel /> : null}
                <div className={`layout-body ${sidePanelPosition}`}>
                    {showSide ? <aside className={`layout-sidepanel ${searchFocused ? 'search-mode' : 'category-mode'}`}>{sidePanelContent}</aside> : null}
                    <main className="layout-main">{mainContent}</main>
                </div>
                {selectedMedia ? null : <Gutter side='left' />}
                {selectedMedia ? null : <Gutter side="right" />}
                {params?.id ? null : <Footer />}
            </div>
            {/* {claims?.player ? <div style={{ position: 'fixed', left: 0, top: 0, zIndex: 1000 }}>
                <ProfileSection />
            </div> : ''} */}
        </>
    );
};

export default MainComponent;

export function extractSubdomain(url: string): string | null {
    let domain = getCurrentDomainWithoutSubdomain();
    const pattern = new RegExp(`^https?:\/\/([a-zA-Z0-9-]+)\\.${domain}`);
    const match = url.match(pattern);
    return match ? match[1] : null;
}

export function hasSubdomain(url: string): boolean {
    const pattern = /^https?:\/\/([a-zA-Z0-9-]+)\..+/;
    return pattern.test(url);
}
export function getCurrentDomainWithoutSubdomain() {
    const currentUrl = window.location.hostname;
    const domainParts = currentUrl.split(".");

    // Check if there's a subdomain, and return the domain without it
    if (domainParts.length > 2) {
        return domainParts.slice(-2).join(".");
    }

    // If there's no subdomain, just return the current domain
    return currentUrl;
}
